import { usePermissionsHook } from "./usePermissionsHook";

/**
 * Who may use the DSCR Sizer: super admins only (owner 2026-10-16). Admins and
 * the "Sizer Visibility" group keep the rest of the Sizers section (see
 * useCanSeeSizers) but not this tab. Read by the header menu, the Sizers tab
 * strip, the /sizers/dscr route and Priced Scenarios.
 */
export const useCanUseDscrSizer = () =>
  Boolean(usePermissionsHook().isSuperAdmin);

export default useCanUseDscrSizer;
